import { useState } from "react";
import { Crown } from "lucide-react";
import { FOOD } from "../data/images";

export const FoodImg = ({ src, alt, className = "", imgClassName = "" }) => {
    const [stage, setStage] = useState(0);

    if (stage === 2) {
        return (
            <div
                className={`bg-elevated flex items-center justify-center ${className}`}
                role="img"
                aria-label={alt}
                data-testid="food-image-fallback"
            >
                <Crown className="w-8 h-8 text-brass/50" strokeWidth={1.25} />
            </div>
        );
    }

    return (
        <img
            src={stage === 0 ? src : FOOD.spices}
            alt={alt}
            loading="lazy"
            decoding="async"
            onError={() => setStage((s) => s + 1)}
            className={`${className} ${imgClassName}`}
        />
    );
};
